import type { Condition } from "../types";

export function getConditionReference(condition: Condition) {
  return condition.reference ?? condition.resource_data?.id;
}
